var app = app || {};

app.imgsize = (function ($) {
    // emulates background-size(cover) on inline images - used on the homepage for the responsive carousel
	imgSize = function() {
        $('#carousel').imagesLoaded()
        .progress(function(instance, image) {
            paneHeight = $('#carousel').height();
            paneWidth = $('#carousel').width();
            paneRatio = paneHeight/paneWidth;
            imgHeight = $(image.img).height();
            imgWidth = $(image.img).width();
            imgRatio = imgHeight/imgWidth;

            if (paneRatio>=imgRatio) {
                $(image.img).css({top:'0px', height:paneHeight+'px', width:'auto'});
                leftPos=(($(image.img).parent().width()-$(image.img).width())/2);
                $(image.img).css({left:leftPos+'px'});
            }
            else {
                $(image.img).css({left:'0px', width:paneWidth+'px', height:'auto'});
                topPos=(($(image.img).parent().height()-$(image.img).height())/2);
                $(image.img).css({top:topPos+'px'});
            }
        });
    },

    imgResize = function() {
        $(window).on("debouncedresize", function( event ) {
            imgSize();
        });
	},
    init = function () {
        imgSize();
        imgResize();

    };
    return {
        init: init
    }    	

}( jQuery, this ));

jQuery(app.imgsize.init);